import request from "../../../../util/request";
import Cookies from 'js-cookie';
export function deleteBotRequest(bot_id,bot_name, callback) {
    return request(
        '/deleteBot',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                bot_id,
                bot_name
            },
        },
        callback
    );
}

export function getBotsListRequest(space_id,status, page_num, page_size, callback) {
    return request(
        '/getBotList',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                space_id,
                page_num,
                page_size,
                status
            },
        },
        callback
    );
}

export function unpublishBotRequest(bot_id, callback) {
    return request(
        '/unpublishBot',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                bot_id
            },
        },
        callback
    );
}
//获取知识库列表
export function getDatasetsListRequest(data, callback) {
    return request(
        '/zhishiku/getDatasets',
        {
            method: 'POST',
            body: data,
        },
        callback
    );
}
//删除知识库接口
export function delDatasets(data, callback) {
  return request(
    '/zhishiku/deldatasets',
    {
      method: 'POST',
      body: data,
    },
    callback
  );
}